import { Button, IconButton, Menu, MenuItem, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";

import MenuTaxes from "../MenuTaxes";
import AddIcon from '@mui/icons-material/Add';
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import AlertDialog from "elements/AlertDialog";
import ListPagination from "elements/ListPagination";
import { ApiRequest } from "GlobalFunctions";
import TaxTypesEditor from "./TypesEditor";

export default function TaxTypes(props : any) {

    const { setLoading } = props;
    const { enqueueSnackbar } = useSnackbar();
    const [list, setList] = useState<any[]>([]);
    const [pagination, setPagination] = useState({
        total_pages: 1,
        total_items: 0,
    });
    const currentPage = 1;
    const [page, setPage] = useState(currentPage);
    const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);
    const [activeItem, setActiveItem] = useState<any>(null);
    const [openAlert, setOpenAlert] = useState(false);
    
    // Editor state
    const [openEditor, setOpenEditor] = useState(false);
    const [editingTypeId, setEditingTypeId] = useState<any>(null);
    

    /*==========================================================
    LOAD LIST
    ==========================================================*/
    const loadList = () => {
        setLoading(true);
        ApiRequest({
            method: 'GET',
            url: '/admin/taxes/types/list',
            query: { page: page },
            setResponse: (response: any) => {
                setList(response.list);
                setPagination(response.pagination);
                setLoading(false);
            }
        })
    }

    /*==========================================================
    DELETE FUNCTIONS
    ==========================================================*/
    const handleDelete = (item: any) => {
        setActiveItem(item.id);
        setOpenAlert(true);
        handleMenuClose(); // Close the menu when delete is clicked
    };

    const deleteItem = () => {
        ApiRequest({
            method: "POST",
            url: "/admin/taxes/types/deleteItem",
            body: { id: activeItem },
            setResponse: (response: any) => {
                if (response.status === "success") {
                    enqueueSnackbar("Tax type deleted successfully", { variant: "success" });
                    loadList();
                }
            },
        });
        setOpenAlert(false);
    };

    /*==========================================================
    EDITOR FUNCTIONS
    ==========================================================*/
    const handleAddNew = () => {
        setEditingTypeId(null);
        setOpenEditor(true);
    };

    const handleEdit = (item: any) => {
        setEditingTypeId(item.id);
        setOpenEditor(true);
        handleMenuClose();
    };

    /*==========================================================
    MENU FUNCTIONS
    ==========================================================*/
    const handleMenuOpen = (event: React.MouseEvent<HTMLElement>, item: any) => {
        setMenuAnchor(event.currentTarget);
        setActiveItem(item);
    };

    const handleMenuClose = () => {
        setMenuAnchor(null);
    };

    useEffect(() => {
        setLoading(true);
        loadList();
    }, [page]);


    return (
      <div className='ModuleContainer'>
          <div className="ModuleHeader">
              <div className="ComponentTitle">
                  <h1>Tax Types</h1>
              </div>

              <MenuTaxes />

              <div className="ModuleActions">
                  <Button
                      variant="outlined"
                      color="info"
                      className="btnList"
                      startIcon={<AddIcon />}
                      onClick={handleAddNew}
                  >
                      Add Tax Type
                  </Button>
              </div>
          </div>

          <div className='ModuleContent'>
              <TableContainer>
                  <Table>
                      <TableHead>
                          <TableRow>
                              <TableCell>Tax Type</TableCell>
                              <TableCell></TableCell>
                          </TableRow>
                      </TableHead>
                      <TableBody>
                          {list.map((item, i) => (
                              <TableRow key={i}>
                                  <TableCell>{item.name}</TableCell>
                                  <TableCell align="right">
                                      <IconButton onClick={(event) => handleMenuOpen(event, item)}>
                                          <MoreHorizIcon />
                                      </IconButton>
                                  </TableCell>
                              </TableRow>
                          ))}
                      </TableBody>
                  </Table>
              </TableContainer>

              <Menu
                  anchorEl={menuAnchor}
                  open={Boolean(menuAnchor)}
                  onClose={handleMenuClose}
              >
                  <MenuItem
                      onClick={() => handleEdit(activeItem)}
                  >
                      <EditIcon fontSize="small" />
                      Edit
                  </MenuItem>
                  <MenuItem onClick={() => handleDelete(activeItem)}>
                      <DeleteOutlineOutlinedIcon fontSize="small" />
                      Remove
                  </MenuItem>
              </Menu>

              <ListPagination
                  pagination={pagination}
                  page={page}
                  onChange={(event: any, value: any) => setPage(value)}
                  label="Tax Types"
              />
          </div>

          <AlertDialog
              open={openAlert}
              setOpen={setOpenAlert}
              subtitle="Are you sure you want to delete this tax type?"
              send={deleteItem}
          />

          <TaxTypesEditor
              setLoading={setLoading}
              openEditor={openEditor}
              setOpenEditor={setOpenEditor}
              type_id={editingTypeId}
              loadList={loadList}
          />
      </div>
    )
}
